import { render, staticRenderFns } from "./DataUpPackageDown.vue?vue&type=template&id=90229fe0&scoped=true&"
import script from "./DataUpPackageDown.vue?vue&type=script&lang=js&"
export * from "./DataUpPackageDown.vue?vue&type=script&lang=js&"
import style0 from "./DataUpPackageDown.vue?vue&type=style&index=0&id=90229fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90229fe0",
  null
  
)

export default component.exports